<template>
    <st-combobox-styled>
        <st-input
            v-model="_value"
            :icon="icon"
            :width="width"
            :block="block"
            :size="size"
            :placeholder="placeholder"
            :disabled="disabled"
            :readonly="readonly"
            @enter="$emit('enter')"
            @focus="active = true"
        />

        <div class="combobox-loading">
            <st-loading :visible="loading" :size="2.4" :stroke="2" />
            <div class="combobox-close" v-if="!loading && value" @click="clearHandler">
                <awesome-icon name="times-circle" />
            </div>
        </div>

        <transition name="st-drop-down-transition">
            <div v-if="not_search_active" class="combobox-valuable">
                <slot name="empty">
                    <div class="default-empty">"{{ tempValue }}" 학교를 찾지 못했습니다.</div>
                </slot>
            </div>
        </transition>

        <transition name="st-drop-down-transition">
            <div v-show="list_active" class="combobox-valuable" ref="combobox_list">
                <div class="combobox-list">
                    <div v-for="(item, index) in todos" :key="todoKey ? item[todoKey] : index.toString()">
                        <slot name="item" v-bind="{ ...item, index, onRowClick: cb => rowClickHandler(item, cb) }" />
                    </div>
                </div>
            </div>
        </transition>
    </st-combobox-styled>
</template>
<script>
import styled from "vue-styled-components";
import { props as InputProps } from "./StInput";
import { scrollCalculator } from "../utils/lib";

const props = {};

const StComboBoxStyled = styled("div", props)`
    position: relative;

    .combobox-loading {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 16px;

        .combobox-close {
            font-size: 1.7rem;
            color: ${props => props.theme.color.disabled};
            cursor: pointer;
        }
    }

    .combobox-valuable {
        position: absolute;
        top: 100%;

        width: 100%;
        background-color: #fff;
        border-radius: 0 0 5px 5px;
        border: 1px solid ${props => props.theme.color.line};
        max-height: 50vh;
        overflow-y: auto;
        box-shadow: 0px 5px 7px 0 rgba(0, 0, 0, 0.1);
        font-size: 1.4rem;

        .default-empty {
            padding: 2.4rem;
            font-size: 1.6rem;
            color: ${props => props.theme.color.disabled};
        }
    }

    .combobox-list {
        & > div + div {
            border-top: 1px solid ${props => props.theme.color.line};
        }
    }
`;

export default {
    name: "StComboBox",
    data: () => ({
        time: null,
        active: false,
        tempValue: null // complate 된 검색어
    }),
    props: {
        ...InputProps,
        todos: Array,
        todoKey: String,
        placeholder: String,
        loading: Boolean,
        value: String,
        scrollDistance: Number,
        isLabel: String,
        type: {
            type: String,
            default: () => "text"
        },
        disabled: {
            type: Boolean,
            default: () => false
        },
        readonly: {
            type: Boolean,
            default: () => false
        },
        debounce: {
            type: Number,
            default: () => 800
        }
    },
    computed: {
        _value: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit("input", value);
                this.debounceHandler(value);
            }
        },

        not_search_active() {
            return this.tempValue && this.todos.length === 0 && this.value && !this.loading;
        },

        list_active() {
            return this.active && this.todos.length !== 0 && this.value;
        }
    },
    methods: {
        // 검색 대기 -> 입력시 debounce 기능
        debounceHandler(value) {
            if (this.time) {
                clearTimeout(this.time);
                this.time = null;
            }

            if (!this.time) {
                this.time = setTimeout(() => {
                    this.searchHandler(value);
                }, this.debounce);
            }
        },

        // debounce 의 time out 이 지나면 실행
        searchHandler(value) {
            this.tempValue = value;
            this.$emit("complate", value);
            this.active = true;
            this.time = null;
        },

        clearHandler() {
            this.active = false;
            this.$emit("input", null);
        },

        rowClickHandler(item, cb) {
            // this.$emit("input", item[this.isLabel]);
            cb && cb();
            this.active = false;
        },

        infiniteScrollHandler(ev) {
            const { offsetHeight, scrollHeight, scrollTop } = ev.target;
            scrollCalculator(offsetHeight, scrollHeight, scrollTop, this.scrollDistance, () => this.$emit("infinite"));
        },

        toggle() {
            if (this.active) {
                this.active = false;
            }
        }
    },
    mounted() {
        this.$refs.combobox_list.addEventListener("scroll", this.infiniteScrollHandler);
        document.addEventListener("mousedown", this.toggle);
    },
    beforeDestroy() {
        this.$refs.combobox_list.removeEventListener("scroll", this.infiniteScrollHandler);
        document.removeEventListener("mousedown", this.toggle);
    },
    components: {
        "st-combobox-styled": StComboBoxStyled
    }
};
</script>
